import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsCompaniesContractPlanLogsIndexResponseType } from "~/domains";

type RequestDataType = {
  page?: number;
  companyId: string;
};

const request = async ({
  page = 1,
  companyId,
}: RequestDataType): Promise<ApisAdminOperatorsCompaniesContractPlanLogsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsCompaniesContractPlanLogsIndexResponseType>(
      `/api/admin_operators/companies/${companyId}/contract_plan_logs`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: InfiniteQueryConfigType<QueryFnType>;
  companyId: string;
};

export const useApisAdminOperatorsCompaniesContractPlanLogsIndex = ({
  companyId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApisAdminOperatorsCompaniesContractPlanLogsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisAdminOperatorsCompaniesContractPlanLogsIndex", companyId],
    ({ pageParam }) => {
      return request({ companyId, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
